import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';
import ResourceProperty from '../../../common/resource/ResourceProperty';
import { tzNormalizeDate } from '../../../../utils/date';
import { DATE_FORMAT, DATE_TIME_FORMAT } from '../../../../config/locale';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import Table from '../../../common/Table';
import Checkbox from '../../../common/forms/Checkbox';
import { BUS_PATH, CIRCUIT_PATH } from '../../../../config/paths';

const BusAssignmentScheduleBasicInformationResource = ({
  id,
  createDate,
  startDate,
  endDate,
  user,
  busAssignmentScheduleBusList,
  circuitList,
  active,
}) => (
  <>
    <Row>
      <Col md={6}>
        <ResourceProperty label="ID: ">{id}</ResourceProperty>
        <ResourceProperty label="Fecha de inicio: ">
          {tzNormalizeDate({
            date: startDate,
            format: DATE_FORMAT,
          })}
        </ResourceProperty>
        <ResourceProperty label="Fecha de fin: ">
          {tzNormalizeDate({
            date: endDate,
            format: DATE_FORMAT,
          })}
        </ResourceProperty>
        <ResourceProperty label="Activo: ">
          <Checkbox checked={active} />
        </ResourceProperty>
      </Col>
      <Col md={6}>
        <h3>Datos Internos</h3>
        <ResourceProperty label="Creado por: ">
          {user.fullName} - {user.username}
        </ResourceProperty>
        <ResourceProperty label="Fecha de creación: ">
          {tzNormalizeDate({
            date: createDate,
            format: DATE_TIME_FORMAT,
          })}
        </ResourceProperty>
      </Col>
    </Row>
    <Row>
      <Col md={6}>
        <h3>Buses</h3>
        <Table
          columns={[
            {
              Header: 'Número de Bus',
              accessor: 'companyBusId',
              className: 'text-center',
            },
            {
              Header: 'Matrícula',
              accessor: 'licensePlate',
              className: 'text-center',
            },
          ]}
          data={busAssignmentScheduleBusList.map((bus) => ({
            companyBusId: bus.registeredBus.companyBusId,
            licensePlate: bus.registeredBus.licensePlate,
            id: bus.busId
          }))}
          defaultPageSize={
            busAssignmentScheduleBusList.length || DEFAULT_PAGE_SIZE
          }
          showPagination={false}
          showPageSizeOptions={false}
          manual={false}
          modelPath={BUS_PATH}
          navigateToModelOnRowClick
          openPathInNewTab
        />
      </Col>
      <Col md={6}>
        <h3>Circuito Asignado</h3>
        <Table
          columns={[
            {
              Header: 'ID',
              accessor: 'id',
              className: 'text-center',
            },
            {
              Header: 'Nombre del Circuito',
              accessor: 'name',
              className: 'text-center',
            },
          ]}
          data={circuitList}
          defaultPageSize={circuitList.length || DEFAULT_PAGE_SIZE}
          showPagination={false}
          showPageSizeOptions={false}
          manual={false}
          modelPath={CIRCUIT_PATH}
          navigateToModelOnRowClick
          openPathInNewTab
        />
      </Col>
    </Row>
  </>
);

BusAssignmentScheduleBasicInformationResource.propTypes = {
  id: PropTypes.number.isRequired,
  startDate: PropTypes.number.isRequired,
  endDate: PropTypes.number.isRequired,
  busAssignmentScheduleBusList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      busId: PropTypes.number,
      registeredBus: PropTypes.shape({
        id: PropTypes.number,
        companyBusId: PropTypes.string,
        licensePlate: PropTypes.string,
      }),
    }),
  ).isRequired,
  circuitList: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),
  ).isRequired,
  user: PropTypes.shape({
    id: PropTypes.number,
    fullName: PropTypes.string,
    username: PropTypes.string,
  }).isRequired,
  createDate: PropTypes.number.isRequired,
  active: PropTypes.bool.isRequired,
};

export default BusAssignmentScheduleBasicInformationResource;
